<template>
  <ForieLoader v-show="showLoader && this.$store.state.domainSystemX == 1" />
  <TeLoader v-show="showLoader && this.$store.state.domainSystemX == 2" />

  <div class="mt-2 container">
    <div class="row">
      <div v-show="hasFilterItems" class="col-md-3">
        <div class="card bg-dark text-white">
          <div class="card-header">
            {{ this.$store.getters.getWordLocale("txt_filterleme") }}
          </div>
          <div class="card-body">
            <div v-show="hasCategory">
              <label class="form-label">
                {{ this.$store.getters.getWordLocale("txt_kategori") }}</label
              >
              <Select2
                :options="mainCategories"
                v-model="selectedMainCategory"
                @select="setSelectedMainCategory($event.id)"
              />

              <label v-show="selectedMainCategory > 0" class="form-label mt-2">
                {{
                  this.$store.getters.getWordLocale("txt_alt_katrgori")
                }}</label
              >
              <Select2
                v-show="selectedMainCategory > 0"
                :options="subCategories"
                @select="setSelectedSubCategory($event.id)"
              />
              <hr />
            </div>

            <div v-show="hasKeywords">
              <label class="form-label mt-2">
                {{ this.$store.getters.getWordLocale("txt_ara") }}</label
              >
              <input
                v-model="searchText"
                type="text"
                class="form-control"
                :placeholder="
                  this.$store.getters.getWordLocale(
                    'txt_anahtar_kelime_ile_ara'
                  )
                "
              />

              <hr />
            </div>

            <div v-show="hasSegments">
              <label class="form-label mt-2">
                {{
                  this.$store.getters.getWordLocale("txt_faaliyet_alanlari")
                }}</label
              >
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="businessSegment"
                  id="allSegments"
                  v-on:change="setSelectedBusinessSegment(0)"
                  :checked="selectedBusinessSegment == 0"
                />
                <label class="form-check-label" for="allSegments">
                  {{ this.$store.getters.getWordLocale("txt_tumu") }}
                </label>
              </div>

              <div
                class="form-check"
                v-for="(segment, index) in businessSegments"
                :key="index"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  name="businessSegment"
                  :id="'segment-' + index"
                  v-on:change="setSelectedBusinessSegment(segment.value)"
                  :checked="selectedBusinessSegment == segment.value"
                />
                <label class="form-check-label" :for="'segment-' + index">
                  {{ segment.label }}
                </label>
              </div>

              <hr />
            </div>

            <div v-show="hasCountry">
              <label class="form-label mt-2">
                {{ this.$store.getters.getWordLocale("txt_ulke") }}</label
              >
              <Select2
                :options="countries"
                v-model="selectedCountry"
                @select="setSelectedCountry($event.id)"
              />
            </div>

            <div class="mt-4" v-show="hasFilterItems">
              <button
                v-on:click="getCompaniesList(0)"
                type="button"
                class="float-end btn btn-dark btn-sm"
              >
                {{ this.$store.getters.getWordLocale("txt_ara") }}
              </button>
              <button
                type="button"
                v-on:click="clearFilters"
                class="float-end btn btn-danger btn-sm me-2"
              >
                {{ this.$store.getters.getWordLocale("txt_sifirla") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div :class="hasFilterItems == true ? 'col-md-9' : 'col-md-12'">
        <div class="card bg-dark text-white">
          <div class="card-header">
            {{ this.$store.getters.getWordLocale("txt_firma_listesi") }}
          </div>
          <div class="card-body">
            <div
              class="card bg-dark text-white mb-2 p-1 company-card"
              v-for="(company, index) in companiesListData"
              :key="index"
            >
              <div class="row">
                <div class="col-md-2">
                  <img
                    class="company-logo"
                    v-bind:src="company.logo"
                    :alt="company.name"
                  />
                </div>
                <div class="col-md-10">
                  <div>
                    <router-link
                      :companyId="company.id"
                      :to="
                        '/' +
                        this.$store.state.langCodeX +
                        '/company/' +
                        company.link
                      "
                    >
                      <b>
                        <WordHighlighter
                          :query="this.$store.state.searchInputValueX"
                        >
                          {{ company.name }}
                        </WordHighlighter>
                      </b>
                    </router-link>
                  </div>
                  <div class="company-description">
                    <WordHighlighter
                      :query="this.$store.state.searchInputValueX"
                      v-html="company.description"
                    >
                    </WordHighlighter>
                  </div>
                  <div class="company-keywords">
                    <WordHighlighter
                      v-for="(keyword, i) in company.keywords"
                      :key="i"
                      :query="this.$store.state.searchInputValueX"
                    >
                      {{ keyword }}
                    </WordHighlighter>
                  </div>

                  <div class="company-info d-flex">
                    <div class="company-country d-flex">
                      <country-flag
                        :country="company.countryCode"
                        size="small"
                      />
                      <small>{{ company.countryName }}</small>
                    </div>
                    <span class="separator">|</span>
                    <div v-show="company.isVip" class="is-company-vip">
                      <i class="fas text-warning fa-gem"></i>
                      <small>{{
                        this.$store.getters.getWordLocale("txt_vip_uye")
                      }}</small>
                    </div>

                    <div v-show="!company.isVip" class="is-company-vip">
                      <i class="fas fa-suitcase"></i>
                      <small>{{
                        this.$store.getters.getWordLocale("txt_standart_uye")
                      }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              v-show="noMoreCompanies == false"
              v-on:click="getCompaniesList(currentPage + 1)"
              class="btn w-100 btn btn-outline-warning mt-2 btn-lg"
            >
              {{ this.$store.getters.getWordLocale("txt_daha_fazla_yukle") }}
            </button>

            <div v-show="noMoreCompanies" class="alert alert-info" role="alert">
              <h4 class="alert-heading">
                <i class="fa fa-info-c1ircle"></i>
                {{
                  this.$store.getters.getWordLocale("txt_simdilik_bu_kadar")
                }}!
              </h4>
              <p>
                {{
                  this.$store.getters.getWordLocale(
                    "txt_sitemizin_firma_listesi_surekli_guncelleniyor"
                  )
                }}
              </p>
              <hr />
              <p class="mb-0">
                {{ this.$store.getters.getWordLocale("txt_takipte_kalın") }}
                <i class="fa fa-smile-wink"></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "./helper.js";
import Select2 from "vue3-select2-component";

import CountryFlag from "vue-country-flag-next";
import { mapState } from "vuex";
import WordHighlighter from "vue-word-highlighter";

import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";
export default {
  computed: mapState({
    isSearchChangedX: (state) => state.isSearchChangedX,
    langCodeX: (state) => state.langCodeX,
  }),
  watch: {
    isSearchChangedX(newVal) {
      if (newVal == true) {
        this.searchText = this.$store.state.searchInputValueX;
        this.getCompaniesList(0);
      }
    },
    langCodeX() {
      this.getCompaniesList(0);
      this.reBuildMainCategories();
      this.reBuildSubCategories();
      this.reBuildBusinessSegments();
      this.reBuildCountries();
    },
  },
  data() {
    return {
      showLoader: true,
      countriesFullData: [],
      businessSegmentsFullData: [],
      mainCategoriesFullData: [],
      subCategoriesFullData: [],
      selectedMainAndSubCategories: [],
      companiesListData: [],
      noMoreCompanies: false,
      vipMembershipList: [],
      selectedSegments: [],
      selectedCountries: [],
      selectedCompanies: [],
      selectedCategories: [],
      membershipType: 0,
      keywords: [],
      activation: 0,
      currentPage: 0,
      skipValueCompanies: 0,
      searchText: "",
      hasFilterItems: false,
      selectedMainCategory: 0,
      selectedSubCategory: 0,
      selectedBusinessSegment: 0,
      selectedCountry: 0,
      mainCategories: [],
      subCategories: [],
      businessSegments: [],
      countries: [],
      hasCategory: false,
      hasKeywords: false,
      hasSegments: false,
      hasCountry: false,
    };
  },
  components: {
    ForieLoader,
    TeLoader,
    Select2,
    CountryFlag,
    WordHighlighter,
  },
  methods: {
    async getMainCategories() {
      var temp = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getMainCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (temp = data))
        .catch((err) => console.log(err.message));

      this.mainCategoriesFullData = temp;

      temp.forEach((element) => {
        var mainCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.mainCategoryId == mainCategoryId
            ).length > 0
          ) {
            this.mainCategories.push({
              text: name,
              id: mainCategoryId,
            });
          }
        } else {
          this.mainCategories.push({
            text: name,
            id: mainCategoryId,
          });
        }
      });

      this.mainCategories.unshift({
        text: this.$store.getters.getWordLocale("txt_tumu"),
        id: 0,
      });
    },
    async getSubCategories() {
      if (this.selectedMainCategory == 0) {
        this.subCategories = [];
        return;
      }
      var mainIdList = [];
      mainIdList.push(this.selectedMainCategory);
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getSubCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoryIdList: mainIdList,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.subCategories = data))
        .catch((err) => console.log(err.message));

      this.subCategoriesFullData = this.subCategories;
      var tempList = [];
      this.subCategories.forEach((element) => {
        var subCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;

        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.categoryId == subCategoryId
            ).length > 0
          ) {
            tempList.push({
              text: name,
              id: subCategoryId,
            });
          }
        } else {
          tempList.push({
            text: name,
            id: subCategoryId,
          });
        }
      });
      this.subCategories = [];
      this.subCategories = tempList;
    },
    async getBusinessSegments() {
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getBusinessSegments`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.businessSegments = data))
        .catch((err) => console.log(err.message));

      var tempList = [];
      this.businessSegmentsFullData = this.businessSegments;

      this.businessSegments.forEach((element) => {
        var segmentId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedSegments.length > 0) {
          if (this.selectedSegments.indexOf(segmentId) !== -1) {
            tempList.push({
              label: name,
              value: segmentId,
            });
          }
        } else {
          tempList.push({
            label: name,
            value: segmentId,
          });
        }
      });
      this.businessSegments = [];
      this.businessSegments = tempList;
    },
    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.countriesFullData = tempList;

      tempList.forEach((element) => {
        var countryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedCountries.length > 0) {
          if (this.selectedCountries.indexOf(countryId) !== -1) {
            this.countries.push({
              text: name,
              id: parseInt(element._id),
              flag: element.Flag,
            });
          }
        } else {
          this.countries.push({
            text: name,
            id: parseInt(element._id),
            flag: element.Flag,
          });
        }
      });

      this.countries.unshift({
        text: this.$store.getters.getWordLocale("txt_tum_ulkeler"),
        id: 0,
        flag: "",
      });
    },
    async getCompaniesList(page) {
      this.showLoader = true;

      this.currentPage = page;
      if (this.currentPage == 0) {
        this.companiesListData = [];
        this.skipValueCompanies = 0;
      } else {
        this.skipValueCompanies = this.currentPage * 20;
      }

      if (this.searchText != "") {
        this.$store.state.searchInputValueX = this.searchText;
      } else {
        this.$store.state.searchInputValueX = "";
      }

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompaniesListForDomains`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domainSystem: this.$store.state.domainSystemX,
            activation: this.activation,
            keywords: this.keywords.length == 0 ? null : this.keywords,
            membershipType: this.membershipType,
            selectedCategories:
              this.selectedSubCategory > 0
                ? [this.selectedSubCategory]
                : this.selectedCategories.length == 0
                ? null
                : this.selectedCategories,
            selectedMainCategories:
              this.selectedMainCategory > 0
                ? [this.selectedMainCategory]
                : null,
            selectedCompanies:
              this.selectedCompanies.length == 0
                ? null
                : this.selectedCompanies,
            selectedCountries:
              this.selectedCountry > 0
                ? [this.selectedCountry]
                : this.selectedCountries.length == 0
                ? null
                : this.selectedCountries,
            selectedSegments:
              this.selectedBusinessSegment > 0
                ? [this.selectedBusinessSegment]
                : this.selectedSegments.length == 0
                ? null
                : this.selectedSegments,
            vipMembershipList:
              this.vipMembershipList.length == 0
                ? null
                : this.vipMembershipList,
            search: this.$store.state.searchInputValueX,
            page: this.skipValueCompanies,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companiesList = data))
        .catch((err) => console.log(err.message));

      if (this.companiesList.length < 20) {
        this.noMoreCompanies = true;
      } else {
        this.noMoreCompanies = false;
      }

      this.companiesList.forEach((element) => {
        var companyName = element.Title;
        const dateObject = new Date(
          element.CreateTime
        );
        const createTime = dateObject.toLocaleString();
        var companyId = parseInt(element.SecondaryId);
        var isVip = element.IsVip;
        var countryName =
          element.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length == 0
            ? element.Country.filter((q) => q.LangCode == "en").length == 0
              ? element.Country.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name
              : element.Country.filter((q) => q.LangCode == "en")[0].Name
            : element.Country.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name;
        var countryCode =
          element.Country[0] != null && element.Country[0] != undefined
            ? element.Country[0].Icon
            : "";
        var logo =
          element.Logo == null
            ? this.$store.state.defaultLogoX
            : `https://cdn.turkishexporter.com.tr${element.Logo}`;

        logo = logo.toLowerCase();
        if (
          logo.indexOf(`companies/logo/1`) != -1 ||
          logo.indexOf(`companies/logo/logo`) != -1
        ) {
          logo = this.$store.state.defaultLogoX;
        }

        var companyDescription =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].DescriptionContent
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].DescriptionContent;
        companyDescription =
          companyDescription == null
            ? ""
            : companyDescription.length > 150
            ? `${companyDescription.substr(0, 150)}...`
            : companyDescription;

        var companyKeywords =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Keywords
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Keywords;
        companyKeywords =
          companyKeywords != null
            ? companyKeywords.length == 0
              ? ""
              : companyKeywords.split(",")
            : "";
        var link = element.LinkString;
        this.companiesListData.push({
          id: companyId,
          link: link,
          name: companyName,
          createTime: createTime,
          isVip: isVip,
          countryName: countryName,
          countryCode: countryCode == null ? "" : countryCode.toLowerCase(),
          logo: logo,
          description: companyDescription,
          keywords: companyKeywords,
        });
      });
      this.$store.state.isSearchChangedX = false;
      this.showLoader = false;
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    setSelectedMainCategory(id) {
      this.selectedMainCategory = parseInt(id);

      this.getSubCategories();
    },
    setSelectedSubCategory(id) {
      this.selectedSubCategory = parseInt(id);
    },
    setSelectedBusinessSegment(id) {
      this.selectedBusinessSegment = parseInt(id);
    },
    setSelectedCountry(id) {
      this.selectedCountry = parseInt(id);
    },
    clearFilters() {
      this.selectedMainCategory = 0;
      this.selectedSubCategory = 0;
      this.searchText = "";
      this.selectedBusinessSegment = 0;
      this.selectedCountry = 0;
      this.$store.state.searchInputValueX = "";

      this.getCompaniesList(0);
    },
    reBuildMainCategories() {
      this.mainCategories = [];
      this.mainCategoriesFullData.forEach((element) => {
        var mainCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.mainCategoryId == mainCategoryId
            ).length > 0
          ) {
            this.mainCategories.push({
              text: name,
              id: mainCategoryId,
            });
          }
        } else {
          this.mainCategories.push({
            text: name,
            id: mainCategoryId,
          });
        }
      });

      this.mainCategories.unshift({
        text: this.$store.getters.getWordLocale("txt_tumu"),
        id: 0,
      });
    },
    reBuildSubCategories() {
      this.subCategories = [];
      this.subCategoriesFullData.forEach((element) => {
        var subCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;

        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.categoryId == subCategoryId
            ).length > 0
          ) {
            this.subCategories.push({
              text: name,
              id: subCategoryId,
            });
          }
        } else {
          this.subCategories.push({
            text: name,
            id: subCategoryId,
          });
        }
      });
    },
    reBuildBusinessSegments() {
      this.businessSegments = [];
      this.businessSegmentsFullData.forEach((element) => {
        var segmentId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedSegments.length > 0) {
          if (this.selectedSegments.indexOf(segmentId) !== -1) {
            this.businessSegments.push({
              label: name,
              value: segmentId,
            });
          }
        } else {
          this.businessSegments.push({
            label: name,
            value: segmentId,
          });
        }
      });
    },
    reBuildCountries() {
      this.countries = [];
      this.countriesFullData.forEach((element) => {
        var countryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedCountries.length > 0) {
          if (this.selectedCountries.indexOf(countryId) !== -1) {
            this.countries.push({
              text: name,
              id: parseInt(element._id),
              flag: element.Flag,
            });
          }
        } else {
          this.countries.push({
            text: name,
            id: parseInt(element._id),
            flag: element.Flag,
          });
        }
      });
    },
  },
  mounted() {
    if (this.$store.state.searchInputValueX != "") {
      this.searchText = this.$store.state.searchInputValueX;
    }
    // #region Left Side Filter
    this.hasFilterItems =
      this.$store.state.domainContentX.FilterContent.filter(
        (q) =>
          q.id == "1" && parseInt(q.status) == 1
      ).length > 0
        ? true
        : false;

    if (this.hasFilterItems == true) {
      var filterItems = this.$store.state.domainContentX.FilterContent.filter(
        (q) =>
          q.id == "1" && parseInt(q.status) == 1
      )[0].items;

      this.hasCategory =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 1 && q.status == 1
        ).length > 0;
      this.hasSegments =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 2 && q.status == 1
        ).length > 0;
      this.hasKeywords =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 3 && q.status == 1
        ).length > 0;
      this.hasCountry =
        filterItems.filter(
          (q) =>
            parseInt(q.id) == 4 && q.status == 1
        ).length > 0;

      if (
        this.hasCategory == false &&
        this.hasKeywords == false &&
        this.hasSegments == false &&
        this.hasCountry == false
      ) {
        this.hasFilterItems = false;
      }

      if (this.hasCategory) {
        this.getMainCategories();
      }

      if (this.hasSegments) {
        this.getBusinessSegments();
      }

      if (this.hasCountry) {
        this.getCountries();
      }
    }

    helper.SetSelect2();
    // #endregion

    // #region CompaniesFilter
    var companyContentX = this.$store.state.domainContentX.CompanyContent;
    this.activation = parseInt(companyContentX.Activation);
    var keywords = companyContentX.Keywords;
    this.membershipType = parseInt(
      companyContentX.MembershipType
    );
    var selectedCategories = companyContentX.SelectedCategories;
    var selectedCompanies = companyContentX.SelectedCompanies;
    var selectedCountries = companyContentX.SelectedCountries;
    var selectedSegments = companyContentX.SelectedSegments;
    var vipMembershipList = companyContentX.VipMembershipList;

    if (keywords.length > 0) {
      this.keywords = [];
      keywords.forEach((element) => {
        var text = element.text;
        this.keywords.push(text);
      });
    }

    if (selectedCompanies.length > 0) {
      this.selectedCompanies = [];
      selectedCompanies.forEach((element) => {
        var companyId = parseInt(element.id);
        this.selectedCompanies.push(companyId);
      });
    }

    if (selectedCategories.length > 0) {
      this.selectedCategories = [];
      selectedCategories.forEach((element) => {
        var categoryId = parseInt(element.categoryId);
        var mainCategoryId = parseInt(element.mainCategoryId);

        this.selectedCategories.push(categoryId);
        this.selectedMainAndSubCategories.push({
          mainCategoryId: mainCategoryId,
          categoryId: categoryId,
        });
      });
    }

    if (selectedCountries.length > 0) {
      this.selectedCountries = [];
      selectedCountries.forEach((element) => {
        var countryId = parseInt(element);
        this.selectedCountries.push(countryId);
      });
    }

    if (selectedSegments.length > 0) {
      this.selectedSegments = [];
      selectedSegments.forEach((element) => {
        var segmentId = parseInt(element);
        this.selectedSegments.push(segmentId);
      });
    }

    if (vipMembershipList.length > 0) {
      this.vipMembershipList = [];
      vipMembershipList.forEach((element) => {
        var membershipId = parseInt(element);
        this.vipMembershipList.push(membershipId);
      });
    }
    // #endregion

    this.getCompaniesList(0);
  },
};
</script>

<style scoped>
.select2 {
  width: 100% !important;
}

.company-card {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  box-shadow: 0 0 8px rgb(0 0 0 / 60%);
}

.company-card:hover {
  box-shadow: 0 0 8px rgb(0 0 0 / 60%);
}

.company-logo {
  width: 100%;
  height: 125px;
  border: 1px solid #d8d8d8;
  padding: 2px;
  background: white;
  margin: 2px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.company-keywords {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  max-height: 62px;
  overflow: hidden;
}
.company-keywords span {
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  border-radius: 2px;
  border: solid 1px #dfe5ee;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  margin-top: 5px;
  margin-right: 5px;

  font-size: 12px;
}

.company-country small {
  margin-top: 10px;
  margin-left: 4px;
  font-weight: 900;
  font-size: 12px;
}

.is-company-vip small {
  margin-top: 9px;
  margin-left: 4px;
  font-weight: 900;
  font-size: 12px;
}

.is-company-vip {
  margin-top: 9px;
  margin-left: 6px;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

a {
  text-decoration: none;
  color: white !important;
}

.page-laoder {
  background: #ffffff96 !important;
}
</style>
